import Swiper from 'swiper';
import { Navigation, Pagination, Scrollbar, EffectFade, Autoplay, Mousewheel, Parallax, Controller, Thumbs } from 'swiper/modules';
Swiper.use([Navigation, Pagination, Scrollbar, EffectFade, Autoplay, Mousewheel, Parallax, Controller, Thumbs]);

import SwiperManager from './swiperManager';

$(() => {
  const SwiperFv1 = new Swiper('.swiper-fv-1', {
    slidesPerView: 1,
    loop: true,
    speed: 850,
    autoplay: {
      delay: 3850,
    },
    parallax: true,
    allowTouchMove: false,
    direction: "vertical",
    on: {
      slideChangeTransitionStart: function () {
        setTimeout(() => {
          SwiperFv2.slideNext()
        }, 100);
      }
    },
  })

  const SwiperFv2 = new Swiper('.swiper-fv-2', {
    slidesPerView: 1,
    loop: true,
    speed: 850,
    parallax: true,
    allowTouchMove: false,
    direction: "vertical",
  })

  new Swiper('.swiper-introduction', {
    // loop: true,
    // allowTouchMove: false,
    // autoplay: {
    //   delay: 0,
    // },
    slidesPerView: 2,
    // speed: 8000,

  })

  const speed = 3950

  new Swiper('.swiper-works', {
    loop: true,
    centeredSlides: true,
    speed: 750,
    spaceBetween: 20,
    autoplay: {
      enabled: false,
    },
    navigation: {
      nextEl: '.swiper-button-works-next',
      prevEl: '.swiper-button-works-prev',
    },
    pagination: {
      el: ".progress-pagination-works",
      type: "fraction",
      renderFraction: function (currentClass, totalClass) {
        return '<span class="' + currentClass + '"></span>' + '<span class="progressbar"><span class="progressbar_inner"></span></span>' + '<span class="' + totalClass + '"></span>';
      },
    },
    breakpoints: {
      768: {
        slidesPerView: 1.4,
        spaceBetween: 70,
        autoplay: {
          enabled: true,
          delay: speed,
        },
      }
    },
    on: {
      afterInit: function() {
        const works_bar = document.querySelector('.progress-pagination-works .progressbar_inner')
        works_bar.style.transitionDuration = speed + 'ms',
        works_bar.style.transform = 'scaleX(1)'
      },
      slideChangeTransitionStart: function () {
        const works_bar = document.querySelector('.progress-pagination-works .progressbar_inner')
        works_bar.style.transitionDuration = '0s',
        works_bar.style.transform = 'scaleX(0)'
      },
      slideChangeTransitionEnd: function () {
        const works_bar = document.querySelector('.progress-pagination-works .progressbar_inner')
        works_bar.style.transitionDuration = speed + 'ms',
        works_bar.style.transform = 'scaleX(1)'
      },
    }
  });

  new Swiper('.swiper-standard-space', {
    loop: true,
    centeredSlides: true,
    allowTouchMove: false,
    autoplay: {
      delay: 0,
    },
    slidesPerView: 2.5,
    speed: 8000,
    spaceBetween: 18,
    breakpoints: {
      768: {
        slidesPerView: 3.2,
        speed: 15000,
        spaceBetween: 35,
      }
    }
  })

  new SwiperManager('.swiper-plan', {
    spaceBetween: 20,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-plan-next',
      prevEl: '.swiper-button-plan-prev',
    },
    autoplay: {
      enabled: true,
      delay: speed,
    },
    pagination: {
      el: ".progress-pagination-plan",
      type: "fraction",
      renderFraction: function (currentClass, totalClass) {
        return '<span class="' + currentClass + '"></span>' + '<span class="progressbar"><span class="progressbar_inner"></span></span>' + '<span class="' + totalClass + '"></span>';
      },
    },
    on: {
      afterInit: function() {
        const works_bar = document.querySelector('.progress-pagination-plan .progressbar_inner')
        works_bar.style.transitionDuration = speed + 'ms',
        works_bar.style.transform = 'scaleX(1)'
      },
      slideChangeTransitionStart: function () {
        const works_bar = document.querySelector('.progress-pagination-plan .progressbar_inner')
        works_bar.style.transitionDuration = '0s',
        works_bar.style.transform = 'scaleX(0)'
      },
      slideChangeTransitionEnd: function () {
        const works_bar = document.querySelector('.progress-pagination-plan .progressbar_inner')
        works_bar.style.transitionDuration = speed + 'ms',
        works_bar.style.transform = 'scaleX(1)'
      },
    }
  })

  new SwiperManager('.swiper-security', {
    spaceBetween: 20,
    loop: true,
    autoHeight: true,
    navigation: {
      nextEl: '.swiper-button-security-next',
      prevEl: '.swiper-button-security-prev',
    },
    autoplay: {
      enabled: true,
      delay: speed,
    },
    pagination: {
      el: ".progress-pagination-security",
      type: "fraction",
      renderFraction: function (currentClass, totalClass) {
        return '<span class="' + currentClass + '"></span>' + '<span class="progressbar"><span class="progressbar_inner"></span></span>' + '<span class="' + totalClass + '"></span>';
      },
    },
    on: {
      afterInit: function() {
        const works_bar = document.querySelector('.progress-pagination-security .progressbar_inner')
        works_bar.style.transitionDuration = speed + 'ms',
        works_bar.style.transform = 'scaleX(1)'
      },
      slideChangeTransitionStart: function () {
        const works_bar = document.querySelector('.progress-pagination-security .progressbar_inner')
        works_bar.style.transitionDuration = '0s',
        works_bar.style.transform = 'scaleX(0)'
      },
      slideChangeTransitionEnd: function () {
        const works_bar = document.querySelector('.progress-pagination-security .progressbar_inner')
        works_bar.style.transitionDuration = speed + 'ms',
        works_bar.style.transform = 'scaleX(1)'
      },
    }
  })

  $('.section-gallery').each(function() {
    const sliderThumbnail = new Swiper(this.querySelector(".swiper-gallery-thumbnail"), {
      slidesPerView: 7,
      spaceBetween: 10,
      breakpoints: {
        768: {
          slidesPerView: 9,
          spaceBetween: 18,
        }
      }
    });

    const slider = new Swiper(this.querySelector(".swiper-gallery"), {
      loop: true,
      navigation: {
        nextEl: this.querySelector(".section-gallery__arrow--next"),
        prevEl: this.querySelector(".section-gallery__arrow--prev"),
      },
      thumbs: {
        swiper: sliderThumbnail,
      },
    });
  })

  new SwiperManager('.swiper-warranty-coverage', {
    slidesPerView: 1.2,
    spaceBetween: 30,
    // loop: true,
    navigation: {
      nextEl: '.swiper-button-warranty-coverage-next',
      prevEl: '.swiper-button-warranty-coverage-prev',
    },
    // autoplay: {
    //   enabled: true,
    //   delay: speed,
    // },
  })

  new SwiperManager('.swiper-investigation', {
    slidesPerView: 1.2,
    spaceBetween: 30,
    // loop: true,
    navigation: {
      nextEl: '.swiper-button-investigation-next',
      prevEl: '.swiper-button-investigation-prev',
    },
    // autoplay: {
    //   enabled: true,
    //   delay: speed,
    // },
  })

  $('.section-method-description__wrapper').each(function() {
    new Swiper(this.querySelector('.swiper-method'), {
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
      },
      navigation: {
        nextEl: this.querySelector('.section-method-description__next'),
        prevEl: this.querySelector('.section-method-description__prev'),
      },
    })
  })


})
